export function getSelectedValue(filterName, filterData, query) {
  const filter = filterData.find((filter) => filter.slug === filterName);
  const queryKey = `attributes[${filter.slug}]`;

  if (query[queryKey]) {
    const selectedSlugs = query[queryKey].split(",");
    const selectedValues = selectedSlugs
      .map((slug) => filter.values.find((value) => value.slug === slug))
      .filter(Boolean)
      .map((value) => value.slug);

    return selectedValues.length ? selectedValues : [];
  }

  return [];
}

export function cleanUrl(url) {
  const urlObj = new URL(url, process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL);
  const params = new URLSearchParams(urlObj.search);

  for (const [key, value] of params.entries()) {
    if (key.startsWith("attributes[") && value === "any") {
      params.delete(key);
    }
  }

  urlObj.search = params.toString();

  return urlObj.pathname + (urlObj.search ? `?${urlObj.search}` : "");
}
